/**
 * @file 销售订单模块 - 枚举定义
 * @description 定义销售订单模块使用的所有枚举类型
 * @对应后端 app/Modules/Sales/Models/SalesOrder.php
 * 
 * ⚠️ 注意事项：
 * 1. 枚举值必须与后端完全一致（包括大小写和类型）
 * 2. 从 Model 的 STATUS_*, PRIORITY_* 等常量提取
 * 3. 每个枚举值添加中文注释说明
 * 
 * 📋 更新时机：
 * - 后端添加新的订单状态
 * - 后端添加新的优先级
 * - 后端修改枚举值
 * 
 * ✅ 验证方式：
 * 1. 对照后端 Model 的常量定义
 * 2. 检查枚举值是否完整
 * 3. 检查中文注释是否准确
 * 
 * @last-updated 2025-10-19
 */

/**
 * 销售订单状态枚举
 * @对应后端 SalesOrder::STATUS_*
 */
export enum SalesOrderStatus {
  /** 待审核 */
  PENDING = 1,
  /** 已确认 */
  CONFIRMED = 2,
  /** 生产中 */
  IN_PRODUCTION = 3,
  /** 已完成 */
  COMPLETED = 4,
  /** 已取消 */
  CANCELLED = 5,
}

/**
 * 销售订单优先级枚举
 * @对应后端 SalesOrder::PRIORITY_*
 */
export enum SalesOrderPriority {
  /** 紧急 */
  URGENT = 1,
  /** 高 */
  HIGH = 2,
  /** 中 */
  MEDIUM = 3,
  /** 低 */
  LOW = 4,
}

